import axios from "axios";

export const getSizes = () => axios.get("/sizes", {}).then((res) => res.data);
